import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import { logOut } from "../../redux/reducers/authReducer";
import logoHome from "../../img/logo_home.png";
import rayo from "../../img/rayo.png";
interface Props {
    className: string;
    titles: {
        id: number;
        title: string;
        url?: string;
        sublist?: { id: number; title: string; url: string }[];
    }[];
    handleSmoothScroll: (title: string) => void;
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const BurguerMenu = ({
    className,
    titles,
    handleSmoothScroll,
    setShowModal,
}: Props) => {
    const [showOptions, setShowOptions] = useState(false);
    const dispatch = useAppDispatch();
    const { tags } = useParams();
    const { id, avatar, tipo_usuario } = useAppSelector(
        (state) => state.usuario_logeado
    );

    const [openSublist, setOpenSublist] = useState<number | null>(null); // Estado para rastrear el sublistado abierto

    const toggleSublist = (id: number) => {
        setOpenSublist((prev) => (prev === id ? null : id)); // Alterna entre abrir/cerrar el sublistado
    };

    const [burguerMenuVisible, setBurguerMenuVisible] =
        useState<boolean>(false);
    const navigate = useNavigate();

    return (
        <div className="relative">
            <div
                className={`${className} flex justify-between items-center p-3 bg-white text-blue-500 px-5`}
            >
                <span
                    onClick={() => handleSmoothScroll("inicio")}
                    className="mr-8 font-medium cursor-pointer lg:text-lg"
                >
                    <img src={logoHome} className="w-20" alt="logo blustay" />
                </span>

                <svg
                    onClick={() => setBurguerMenuVisible(true)}
                    className="w-8 h-8 text-[#029DE0] cursor-pointer"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    stroke="currentColor"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <line x1="4" y1="6" x2="20" y2="6" />
                    <line x1="4" y1="12" x2="20" y2="12" />
                    <line x1="4" y1="18" x2="20" y2="18" />
                </svg>
            </div>
            <div
                className={`${
                    burguerMenuVisible ? "w-full xs:w-1/2  p-3" : "w-0 hidden"
                } transition-all ease-out duration-700 h-screen absolute bg-white  text-[#071829] top-0 right-0  flex flex-col gap-4 `}
            >
                <div className="flex justify-end cursor-pointer ">
                    <svg
                        onClick={() => setBurguerMenuVisible(false)}
                        width="33"
                        height="33"
                        viewBox="0 0 33 33"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M13.7917 12.3333C13.3889 11.9306 12.736 11.9306 12.3333 12.3333C11.9305 12.736 11.9305 13.389 12.3333 13.7917L15.0415 16.5L12.3333 19.2084C11.9306 19.611 11.9306 20.2639 12.3333 20.6667C12.736 21.0694 13.389 21.0694 13.7917 20.6667L16.5 17.9585L19.2082 20.6667C19.6109 21.0694 20.2639 21.0694 20.6667 20.6667C21.0694 20.2639 21.0694 19.611 20.6667 19.2082L17.9583 16.5L20.6667 13.7917C21.0694 13.389 21.0694 12.7361 20.6667 12.3333C20.2639 11.9306 19.6109 11.9306 19.2082 12.3333L16.5 15.0416L13.7917 12.3333Z"
                            fill="#029DE0"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M16.5 1.71875C8.33654 1.71875 1.71875 8.33654 1.71875 16.5C1.71875 24.6635 8.33654 31.2812 16.5 31.2812C24.6635 31.2812 31.2812 24.6635 31.2812 16.5C31.2812 8.33654 24.6635 1.71875 16.5 1.71875ZM3.78125 16.5C3.78125 9.47563 9.47563 3.78125 16.5 3.78125C23.5243 3.78125 29.2188 9.47563 29.2188 16.5C29.2188 23.5243 23.5243 29.2188 16.5 29.2188C9.47563 29.2188 3.78125 23.5243 3.78125 16.5Z"
                            fill="#029DE0"
                        />
                    </svg>
                </div>

                <div className="flex flex-col w-full gap-5 mt-2 px-5">
                    {titles.map((title) => (
                        <div key={title.id} className="relative">
                            {/* Opción principal */}
                            <div
                                onClick={() => {
                                    if (title.sublist) {
                                        toggleSublist(title.id); // Alternar sublistado
                                    } else {
                                        if (title.url) {
                                            setBurguerMenuVisible(false);
                                            handleSmoothScroll(title.url);
                                        }
                                    }
                                }}
                                className="font-medium capitalize cursor-pointer flex justify-end items-center text "
                            >
                                <span>{title.title}</span>
                            </div>
                            <hr className="mt-2 bg-white" />

                            {/* Sublistado */}
                            {title.sublist && (
                                <div
                                    className={`overflow-hidden flex flex-col transition-all ease-in-out duration-700 gap-2 ml-4 mt-2  ${
                                        openSublist === title.id
                                            ? "max-h-[200px] opacity-100"
                                            : "max-h-0 opacity-0"
                                    }`}
                                >
                                    {title.sublist.map((subItem) => (
                                        <div
                                            key={subItem.id}
                                            onClick={() => {
                                                setBurguerMenuVisible(false);
                                                handleSmoothScroll(subItem.url);
                                            }}
                                            className="font-normal text-gray-300 capitalize cursor-pointer hover:text-white"
                                        >
                                            {subItem.title}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                    <div className="flex flex-col gap-3 items-end lg:text-sm xl:text-base  2xl:text-lg text-xs">
                        <div
                            onClick={() => {
                                window.open(
                                    "https://calendar.app.google/7aKBqkaqESiPuTtE8"
                                );
                            }}
                            className="px-3 py-1.5 bg-[#029DE0] bg-opacity-10 text-[#029DE0] rounded-lg cursor-pointer hover:bg-opacity-25 "
                        >
                            Agenda tu demo
                        </div>

                        <div
                            onClick={() => setShowModal(true)}
                            className="flex justify-center items-center gap-1 px-3 py-1.5 bg-[#C3EA43] text-[#071829] font-semibold rounded-lg cursor-pointer overflow-hidden hover:scale-105 "
                        >
                            <img
                                src={rayo}
                                alt="rayo"
                                className="animate-rayoflash"
                            />{" "}
                            Crea tu página web
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BurguerMenu;
